import { useState, useEffect } from "react";
import { message } from "antd";
import { IndoorPositioningSymbols } from "../../../../api";

// State holds METERS ONLY. Pixel positions are derived at render time by the
// canvas that draws them, so nothing here has to be re-projected when the
// canvas is resized (or, later, zoomed/panned).
export const useSymbols = (machineID, open = true) => {
  const [symbols, setSymbols] = useState([]);
  const [placedSymbols, setPlacedSymbols] = useState([]);
  const [symbolsLoading, setSymbolsLoading] = useState(false);

  const loadSymbols = async () => {
    if (!machineID) return;

    setSymbolsLoading(true);
    try {
      const response = await IndoorPositioningSymbols.GetSymbols(machineID);
      if (response.code === 200 && Array.isArray(response.data)) {
        setSymbols(response.data);
        const placed = response.data
          .filter(
            (s) =>
              s.position_x_meters !== null &&
              s.position_x_meters !== undefined &&
              s.position_y_meters !== null &&
              s.position_y_meters !== undefined
          )
          .map((s) => ({
            ...s,
            position_meters: {
              x: s.position_x_meters,
              y: s.position_y_meters,
            },
          }));
        setPlacedSymbols(placed);
      } else {
        setSymbols([]);
        setPlacedSymbols([]);
      }
    } catch (error) {
      console.error("載入物件標記失敗:", error);
      message.error("載入物件標記失敗");
      setSymbols([]);
      setPlacedSymbols([]);
    } finally {
      setSymbolsLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      loadSymbols();
    }
  }, [open, machineID]);

  return {
    symbols,
    setSymbols,
    placedSymbols,
    setPlacedSymbols,
    symbolsLoading,
    loadSymbols,
  };
};
